import { IsInt, IsString } from 'class-validator';

export class ForgotPasswordVerifyDto {
  @IsInt()
  code!: number;

  @IsString()
  key!: string;
}
